export var defaultMenuActions = {
  duplicate: 'duplicate',
  rename: 'rename',
  setDefault: 'set-default',
  "delete": 'delete',
  editValue: 'editValue'
};
export var dataHooks = {
  itemRow: 'sbdl-item-row',
  itemLabel: 'sbdl-item-row-label',
  itemValue: 'sbdl-item-row-value',
  actionsMenu: 'sbdl-actionsMenu',
  contentBefore: 'sbdl-content-before',
  contentAfter: 'sbdl-content-after',
  actionDuplicate: defaultMenuActions.duplicate,
  actionRename: defaultMenuActions.rename,
  actionSetDefault: defaultMenuActions.setDefault,
  actionDelete: defaultMenuActions["delete"],
  actionEditValue: defaultMenuActions.editValue
};